// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-card {
  background: #ffffff !important;
  color: #495057 !important;
  box-shadow:
    inset 0px 0px 0px 0px rgba(0, 0, 0, 0.2),
    0px 0px 1px 0px rgba(0, 0, 0, 0.14),
    0 0px 0px 0 rgba(0, 0, 0, 0.12) !important;
  border-radius: 0px !important;
}
.p-button:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 0.2rem transparent !important ;
}
.p-button.p-button-outlined {
  background-color: transparent;
  color: #002133;
  border: 0px solid;
  font-weight: 600;
}
.p-button.p-button-outlined:not(:disabled):hover {
  background-color: transparent;
  color: #002133;
  border: 0px solid;
}
.p-menubar
  .p-menubar-root-list
  > .p-menuitem:not(.p-highlight):not(.p-disabled)
  > .p-menuitem-content:hover {
  color: #495057;
  background-color: #ff9800 !important;
}
.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlighter):hover {
  border-right: 6px solid #ff9800 !important;
}
.p-menubar {
  padding: 0px !important;
  background: #f8f9fa;
  color: #495057;
  border-top: 1px solid #334d4d !important;
  border-left: 0px solid transparent !important;
  border-bottom: 0px solid transparent !important;
  border-right: 0px solid transparent !important;
  border-radius: 0px;
}

.p-menubar
  .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus
  > .p-menuitem-content {
  /* color: white; */
  background: none;
  /* border-right: 10px solid white; */
}
.p-menubar
  .p-menubar-root-list
  > .p-menuitem
  > .p-menuitem-content
  .p-menuitem-link
  .p-menuitem-text {
  color: white !important;
}
.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlighter) {
  border-right: 6px solid #002133 !important;
}
.p-menubar .p-menubar-root-list > .p-menuitem {
  border-bottom: 1px solid #334d4d !important;
  border-radius: 0;
}
/* .p-menubar
  .p-menubar-root-list
  > .p-menuitem.p-focus
  > .p-menuitem-content
  .p-menuitem-link
  .p-menuitem-text {
  color: #002133 !important;
} */
.p-menubar
  .p-menubar-root-list
  > .p-highlighter
  > .p-menuitem-content
  .p-menuitem-link
  .p-menuitem-text {
  color: #002133 !important;
}
.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  border-color: #ff9800;
  color: #ff9800;
  text-decoration: none;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: solid #dee2e6;
  border-width: 0 0 3px 0;
  border-color: transparent transparent #dee2e6 transparent;
  background: #ffffff;
  color: #9e9e9e;
  text-decoration: none;
  padding: 1rem;
  font-weight: 600;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
  transition: box-shadow 0.2s;
  margin: 0 0 -2px 0;
}
.table-first-row-border th {
  border-top: 1px solid #dee2e6; /* Adjust border width and color as needed */
}
.table tbody tr:first-child {
  border-bottom: 0px solid transparent !important;
}

.p-tabview .p-tabview-panels {
  background: #ffffff !important;
  padding: 0px 1rem !important;
  border: 0 none !important;
  color: #495057 !important;
  border-bottom-right-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
}
.xmot-results-tabs .p-tabview-panels {
  padding: 0 !important;
}
.p-radiobutton.p-highlight .p-radiobutton-box {
  border-color: orange;
  background: orange;
}
.p-radiobutton.p-highlight .p-radiobutton-box:hover {
  border-color: orange;
  background: orange;
}
.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight
  .p-radiobutton-box {
  border-color: orange !important;
  background: orange !important;
}
.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible)
  .p-radiobutton-box {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: 0 0 0 0.2rem #a6d5fa !important;
  border-color: orange !important;
}
.p-card .p-card-content {
  padding: 0rem 0 !important;
}
.p-card .p-card-body {
  padding: 0rem !important;
}
.p-panel .p-panel-header {
  border: 0px solid #dee2e6 !important;
  padding: 0rem !important;
  color: #495057 !important;
  background-color: transparent !important;
}
.p-panel .p-panel-header .p-panel-title {
  font-weight: 600 !important;
  color: #002133;
}
.p-panel .p-panel-content {
  padding: 0rem !important;
  border: 1px solid #dee2e6 !important;
  background: #ffffff !important;
  color: #666666 !important;
  border-bottom-right-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
  border: 0 none !important;
  font-weight: 500 !important;
}
.householdSubCategory {
  color: #bdbdbd !important;
  font-size: 13.6px !important;
  font-weight: 600 !important;
}
.p-checkbox.p-highlight .p-checkbox-box {
  border-color: orange;
  background: orange;
}
.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight
  .p-checkbox-box {
  border-color: orange;
  background: orange;
  color: #ffffff;
}
.p-divider.p-divider-horizontal {
  margin: 0.5rem 0 !important;
  padding: 0 1rem !important;
}
.p-password input {
  background-color: transparent !important;
}
.p-checkbox.p-disabled .p-checkbox-box {
  border-color: #999999; /* Light grey border for disabled */
  background-color: #cccccc; /* Light grey background */
  color: #999999; /* Grey color for checkmark */
  cursor: not-allowed !important; /* Change cursor to indicate it's disabled */
}
.p-dropdown {
  font-family: inherit !important; /* Ensure it inherits the project font */
}

.p-dropdown-label {
  font-family: inherit !important; /* Apply the same font to the selected value */
  text-align: left;
}
.p-toast {
  opacity: 1;
}
.p-toast .p-toast-message .p-toast-message-content .p-toast-detail {
  margin: 1.5rem 0 0 0;
  text-align: left;
}
.p-toast .p-toast-message .p-toast-message-content .p-toast-summary {
  font-weight: 700;
  float: inline-start;
}
.date-range-dialog .p-dialog-header {
  padding: 16px 24px;
  border-bottom: 1px solid #ccc;
  color: #002133;
}
.date-range-dialog .p-calendar .p-inputtext {
  border: none;
  border-bottom: 1px solid gray;
}
.p-inputswitch.p-highlight .p-inputswitch-slider {
  background: #d9d9d9;
}
.p-inputswitch.p-highlight .p-inputswitch-slider:before {
  background: #f69a25;
  transform: translateX(1.25rem);
}

#instructionContainer div div {
  width: 100%;
  text-align: left;
  font-size: 14px;
  background: #f5f5f5;
}
#instructionContainer .ql-toolbar {
  font-family: "Montserrat", sans-serif !important;
}
.ql-editor {
  font-family: "Montserrat", sans-serif !important;
}
/* .right-panel-tabs .p-tabview {
  overflow: auto;
  height: 80vh;
}
.right-panel-tabs .p-tabview .p-tabview-nav-container {
  position: sticky;
  top: 0;
  z-index: 10;
} */
.right-panel-tabs .sticky-container-wrapper {
  overflow: auto;
  /* height: calc(100vh - 138px); */
  position: relative;
  margin-bottom: 8px;
}
.right-panel-tabs .sticky-container-wrapper .p-tabview {
  position: sticky;
  top: 0;
  bottom: 0;
}
.right-panel-tabs .sticky-container-wrapper .p-tabview-nav-container {
  position: sticky;
  top: 0;
  bottom: 0;
  z-index: 10;
}
.p-rating .p-rating-item.p-rating-item-active .p-rating-icon {
  color: orange;
}
.p-rating:not(.p-disabled):not(.p-readonly)
  .p-rating-item:hover
  .p-rating-icon {
  color: orange;
}
.p-rating .p-rating-item.p-focus {
  outline: none;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/primecustomdashboard.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB;;;8CAG4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gDAAgD;AAClD;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;AACnB;AACA;;;;EAIE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;EACxC,6CAA6C;EAC7C,+CAA+C;EAC/C,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;;;;;;EAME,uBAAuB;AACzB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;;;;;;;GAOG;AACH;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,yDAAyD;EACzD,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,6BAA6B,EAAE,4CAA4C;AAC7E;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,yCAAyC;AAC3C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;;EAEE,0BAA0B;EAC1B,4BAA4B;EAC5B,2CAA2C;EAC3C,+BAA+B;AACjC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,yBAAyB;EACzB,wCAAwC;AAC1C;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;EAC1C,yCAAyC;EACzC,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,qBAAqB,EAAE,mCAAmC;EAC1D,yBAAyB,EAAE,0BAA0B;EACrD,cAAc,EAAE,6BAA6B;EAC7C,8BAA8B,EAAE,4CAA4C;AAC9E;AACA;EACE,+BAA+B,EAAE,wCAAwC;AAC3E;;AAEA;EACE,+BAA+B,EAAE,8CAA8C;EAC/E,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gDAAgD;AAClD;AACA;;;;;;;;GAQG;AACH;EACE,cAAc;EACd,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;;;EAGE,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".p-card {\n  background: #ffffff !important;\n  color: #495057 !important;\n  box-shadow:\n    inset 0px 0px 0px 0px rgba(0, 0, 0, 0.2),\n    0px 0px 1px 0px rgba(0, 0, 0, 0.14),\n    0 0px 0px 0 rgba(0, 0, 0, 0.12) !important;\n  border-radius: 0px !important;\n}\n.p-button:focus {\n  outline: 0 none !important;\n  outline-offset: 0 !important;\n  box-shadow: 0 0 0 0.2rem transparent !important ;\n}\n.p-button.p-button-outlined {\n  background-color: transparent;\n  color: #002133;\n  border: 0px solid;\n  font-weight: 600;\n}\n.p-button.p-button-outlined:not(:disabled):hover {\n  background-color: transparent;\n  color: #002133;\n  border: 0px solid;\n}\n.p-menubar\n  .p-menubar-root-list\n  > .p-menuitem:not(.p-highlight):not(.p-disabled)\n  > .p-menuitem-content:hover {\n  color: #495057;\n  background-color: #ff9800 !important;\n}\n.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlighter):hover {\n  border-right: 6px solid #ff9800 !important;\n}\n.p-menubar {\n  padding: 0px !important;\n  background: #f8f9fa;\n  color: #495057;\n  border-top: 1px solid #334d4d !important;\n  border-left: 0px solid transparent !important;\n  border-bottom: 0px solid transparent !important;\n  border-right: 0px solid transparent !important;\n  border-radius: 0px;\n}\n\n.p-menubar\n  .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus\n  > .p-menuitem-content {\n  /* color: white; */\n  background: none;\n  /* border-right: 10px solid white; */\n}\n.p-menubar\n  .p-menubar-root-list\n  > .p-menuitem\n  > .p-menuitem-content\n  .p-menuitem-link\n  .p-menuitem-text {\n  color: white !important;\n}\n.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlighter) {\n  border-right: 6px solid #002133 !important;\n}\n.p-menubar .p-menubar-root-list > .p-menuitem {\n  border-bottom: 1px solid #334d4d !important;\n  border-radius: 0;\n}\n/* .p-menubar\n  .p-menubar-root-list\n  > .p-menuitem.p-focus\n  > .p-menuitem-content\n  .p-menuitem-link\n  .p-menuitem-text {\n  color: #002133 !important;\n} */\n.p-menubar\n  .p-menubar-root-list\n  > .p-highlighter\n  > .p-menuitem-content\n  .p-menuitem-link\n  .p-menuitem-text {\n  color: #002133 !important;\n}\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  border-color: #ff9800;\n  color: #ff9800;\n  text-decoration: none;\n}\n.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border: solid #dee2e6;\n  border-width: 0 0 3px 0;\n  border-color: transparent transparent #dee2e6 transparent;\n  background: #ffffff;\n  color: #9e9e9e;\n  text-decoration: none;\n  padding: 1rem;\n  font-weight: 600;\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n  transition: box-shadow 0.2s;\n  margin: 0 0 -2px 0;\n}\n.table-first-row-border th {\n  border-top: 1px solid #dee2e6; /* Adjust border width and color as needed */\n}\n.table tbody tr:first-child {\n  border-bottom: 0px solid transparent !important;\n}\n\n.p-tabview .p-tabview-panels {\n  background: #ffffff !important;\n  padding: 0px 1rem !important;\n  border: 0 none !important;\n  color: #495057 !important;\n  border-bottom-right-radius: 3px !important;\n  border-bottom-left-radius: 3px !important;\n}\n.xmot-results-tabs .p-tabview-panels {\n  padding: 0 !important;\n}\n.p-radiobutton.p-highlight .p-radiobutton-box {\n  border-color: orange;\n  background: orange;\n}\n.p-radiobutton.p-highlight .p-radiobutton-box:hover {\n  border-color: orange;\n  background: orange;\n}\n.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-highlight\n  .p-radiobutton-box {\n  border-color: orange !important;\n  background: orange !important;\n}\n.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible)\n  .p-radiobutton-box {\n  outline: 0 none !important;\n  outline-offset: 0 !important;\n  box-shadow: 0 0 0 0.2rem #a6d5fa !important;\n  border-color: orange !important;\n}\n.p-card .p-card-content {\n  padding: 0rem 0 !important;\n}\n.p-card .p-card-body {\n  padding: 0rem !important;\n}\n.p-panel .p-panel-header {\n  border: 0px solid #dee2e6 !important;\n  padding: 0rem !important;\n  color: #495057 !important;\n  background-color: transparent !important;\n}\n.p-panel .p-panel-header .p-panel-title {\n  font-weight: 600 !important;\n  color: #002133;\n}\n.p-panel .p-panel-content {\n  padding: 0rem !important;\n  border: 1px solid #dee2e6 !important;\n  background: #ffffff !important;\n  color: #666666 !important;\n  border-bottom-right-radius: 3px !important;\n  border-bottom-left-radius: 3px !important;\n  border: 0 none !important;\n  font-weight: 500 !important;\n}\n.householdSubCategory {\n  color: #bdbdbd !important;\n  font-size: 13.6px !important;\n  font-weight: 600 !important;\n}\n.p-checkbox.p-highlight .p-checkbox-box {\n  border-color: orange;\n  background: orange;\n}\n.p-checkbox:not(.p-disabled):has(.p-checkbox-input:hover).p-highlight\n  .p-checkbox-box {\n  border-color: orange;\n  background: orange;\n  color: #ffffff;\n}\n.p-divider.p-divider-horizontal {\n  margin: 0.5rem 0 !important;\n  padding: 0 1rem !important;\n}\n.p-password input {\n  background-color: transparent !important;\n}\n.p-checkbox.p-disabled .p-checkbox-box {\n  border-color: #999999; /* Light grey border for disabled */\n  background-color: #cccccc; /* Light grey background */\n  color: #999999; /* Grey color for checkmark */\n  cursor: not-allowed !important; /* Change cursor to indicate it's disabled */\n}\n.p-dropdown {\n  font-family: inherit !important; /* Ensure it inherits the project font */\n}\n\n.p-dropdown-label {\n  font-family: inherit !important; /* Apply the same font to the selected value */\n  text-align: left;\n}\n.p-toast {\n  opacity: 1;\n}\n.p-toast .p-toast-message .p-toast-message-content .p-toast-detail {\n  margin: 1.5rem 0 0 0;\n  text-align: left;\n}\n.p-toast .p-toast-message .p-toast-message-content .p-toast-summary {\n  font-weight: 700;\n  float: inline-start;\n}\n.date-range-dialog .p-dialog-header {\n  padding: 16px 24px;\n  border-bottom: 1px solid #ccc;\n  color: #002133;\n}\n.date-range-dialog .p-calendar .p-inputtext {\n  border: none;\n  border-bottom: 1px solid gray;\n}\n.p-inputswitch.p-highlight .p-inputswitch-slider {\n  background: #d9d9d9;\n}\n.p-inputswitch.p-highlight .p-inputswitch-slider:before {\n  background: #f69a25;\n  transform: translateX(1.25rem);\n}\n\n#instructionContainer div div {\n  width: 100%;\n  text-align: left;\n  font-size: 14px;\n  background: #f5f5f5;\n}\n#instructionContainer .ql-toolbar {\n  font-family: \"Montserrat\", sans-serif !important;\n}\n.ql-editor {\n  font-family: \"Montserrat\", sans-serif !important;\n}\n/* .right-panel-tabs .p-tabview {\n  overflow: auto;\n  height: 80vh;\n}\n.right-panel-tabs .p-tabview .p-tabview-nav-container {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n} */\n.right-panel-tabs .sticky-container-wrapper {\n  overflow: auto;\n  /* height: calc(100vh - 138px); */\n  position: relative;\n  margin-bottom: 8px;\n}\n.right-panel-tabs .sticky-container-wrapper .p-tabview {\n  position: sticky;\n  top: 0;\n  bottom: 0;\n}\n.right-panel-tabs .sticky-container-wrapper .p-tabview-nav-container {\n  position: sticky;\n  top: 0;\n  bottom: 0;\n  z-index: 10;\n}\n.p-rating .p-rating-item.p-rating-item-active .p-rating-icon {\n  color: orange;\n}\n.p-rating:not(.p-disabled):not(.p-readonly)\n  .p-rating-item:hover\n  .p-rating-icon {\n  color: orange;\n}\n.p-rating .p-rating-item.p-focus {\n  outline: none;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
